import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import IndexView from '../views/IndexView.vue'
import store from '@/store/index'

const routes = [{
  path: "/notFound", //404
  name: "notFound",
  component: () => import("@/views/notFound.vue"),
},
{
  path: "/login", //登录页面
  name: "login",
  component: () => import("@/views/login/loginIndex.vue"),
}, {
  path: '/',
  name: 'home',
  component: IndexView,
  children: [{
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/workPlace',
    name: 'workPlace',
    component: () => import('../views/workPlace.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/taskMore',
    name: 'taskMore',
    component: () => import('../views/workPlaceCp/taskMore.vue'),
    meta: {
      auth: true
    }
  },

  {
    path: '/taskLeader',
    name: 'taskLeader',
    component: () => import('../views/workPlaceCp/taskLeader.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/taskMany',
    name: 'taskMany',
    component: () => import('../views/workPlaceCp/taskMany.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/taskMonthSetList',
    name: 'taskMonthSetList',
    component: () => import('../views/workPlaceCp/taskMonthSetList.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/taskIndex',
    name: 'taskIndex',
    component: () => import('../views/workPlaceCp/taskTable/taskIndex.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: "/IndexCenter", //个人中心
    name: "IndexCenter",
    component: () => import("@/views/personalCenter/IndexCenter.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/dealData", //交易分析--交易数据
    name: "dealData",
    component: () => import("@/views/transaction/DealData.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/OrderData", //交易分析--订单数据
    name: "OrderData",
    component: () => import("@/views/transaction/OrderData.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/DistriBution", //交易分析--订单数据
    name: "DistriBution",
    component: () => import("@/views/transaction/DistriBution.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/goodsView", //商品分析--商品主页
    name: "goodsView",
    component: () => import("@/views/goodsCenter/goodsView.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/varietyComparison", //商品分析--商品主页
    name: "varietyComparison",
    component: () => import("@/views/goodsCenter/varietyComparison.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: '/goodsList', //商品画像-列表
    name: 'goodsList',
    component: () => import('@/views/goodsCenter/goodsList.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/goodsDetail', //商品画像-详情页
    name: 'goodsDetail',
    component: () => import('@/views/goodsCenter/goodsDetail.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/goodsRankingList', //商品排行榜
    name: 'goodsRankingList',
    component: () => import('@/views/goodsCenter/goodsRankingList.vue'),
    meta: {
      auth: true
    }
  },
  // brandAnalysis
  {
    path: '/brandAnalysis', //品牌分析
    name: 'brandAnalysis',
    component: () => import('@/views/brandAnalysi/brandAnalysis.vue'),
    meta: {
      auth: true
    }
  },
  //hotBrandInfo
  {
    path: '/hotBrandInfo', //品牌分析 热销商品
    name: 'hotBrandInfo',
    component: () => import('@/views/brandAnalysi/hotBrandInfo.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/categoryAnalysis', //品类分析
    name: 'categoryAnalysis',
    component: () => import('@/views/goodsCenter/categoryAnalysis.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/categoryDetails', //品类分析-品类详情
    name: 'categoryDetails',
    component: () => import('@/views/goodsCenter/categoryDetails.vue'),
    meta: {
      auth: true
    }
  },
  // postSale
  {
    path: '/postSale', //品类分析-品类详情
    name: 'postSale',
    component: () => import('@/views/goodsCenter/postSale.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/userData', //用户分析-用户数据
    name: 'userData',
    component: () => import('@/views/user/UserData.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/userPortrayal', //用户分析-用户画像
    name: 'userPortrayal',
    component: () => import('@/views/user/UserPortrayal.vue'),
    meta: {
      auth: true
    }
  },
  // userPortrait

  {
    path: '/userPortrait', //用户分析-用户画像
    name: 'userPortrait',
    component: () => import('@/views/user/userPortrait.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/trendData', //用户分析-用户趋势
    name: 'trendData',
    component: () => import('@/views/user/TrendData.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/activeData', //用户分析-活跃用户
    name: 'activeData',
    component: () => import('@/views/user/ActiveData.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/keepData', //用户分析-用户留存
    name: 'keepData',
    component: () => import('@/views/user/KeepData.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/territoryData', //用户分析-地域分布
    name: 'territoryData',
    component: () => import('@/views/user/TerritoryData.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/terminalData', //用户分析-地域分布
    name: 'terminalData',
    component: () => import('@/views/user/TerminalData.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/userAftersales', //用户分析-用户售后
    name: 'userAftersales',
    component: () => import('@/views/user/userAftersales.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/loginData', //用户分析-注册认证数据
    name: 'loginData',
    component: () => import('@/views/user/LoginData.vue'),
    meta: {
      auth: true
    }
  },
  // hotKeywords
  {
    path: '/hotKeywords', //搜索分析-热门关键词
    name: 'hotKeywords',
    component: () => import('@/views/searchCenter/hotKeywords.vue'),
    meta: {
      auth: true
    }
  },
  // searchDetail
  {
    path: '/searchDetail', //搜索分析-热门关键词
    name: 'searchDetail',
    component: () => import('@/views/searchCenter/searchDetail.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/searchLeaderboard', //搜索分析-热搜排行榜
    name: 'searchLeaderboard',
    component: () => import('@/views/searchCenter/searchLeaderboard.vue'),
    meta: {
      auth: true
    }
  },
  //预警分析
  {
    path: '/abnormalGoods', //预警分析--异常商品
    name: 'abnormalGoods',
    component: () => import('@/views/earlyWarnCenter/abnormalGoods.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/abnormalCustomers', //预警分析--异常商品
    name: 'abnormalCustomers',
    component: () => import('@/views/earlyWarnCenter/abnormalCustomers.vue'),
    meta: {
      auth: true
    }
  },
  // abnormalBehavior   //预警分析--异常行为
  {
    path: '/abnormalBehavior', //预警分析--异常商品
    name: 'abnormalBehavior',
    component: () => import('@/views/earlyWarnCenter/abnormalBehavior.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/abnormalOrder', //预警分析--异常商品
    name: 'abnormalOrder',
    component: () => import('@/views/earlyWarnCenter/abnormalOrder.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/unpurchasedCustomers', //预警分析--异常商品
    name: 'unpurchasedCustomers',
    component: () => import('@/views/earlyWarnCenter/unpurchasedCustomers.vue'),
    meta: {
      auth: true
    }
  },
  //页面分析
  {
    path: '/pagePath', //页面分析--页面路径
    name: 'pagePath',
    component: () => import('@/views/pageAnalysis/pagePath/pagePath.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/visitorsRecord', //页面分析--访客记录
    name: 'visitorsRecord',
    component: () => import('@/views/pageAnalysis/visitorsRecord/visitorsRecord.vue'),
    meta: {
      auth: true
    }
  },
  //用户管理
  {
    path: '/userManagement', //系统管理-用户管理
    name: 'userManagement',
    component: () => import('@/views/systemManagement/userManagement/userManagement.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/rolesManagement', //系统管理-角色管理
    name: 'rolesManagement',
    component: () => import('@/views/systemManagement/rolesManagement/rolesManagement.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/xsList', //系统管理-角色管理
    name: 'xsList',
    component: () => import('@/views/systemManagement/rolesManagement/xsList.vue'),
    meta: {
      auth: true
    }
  },
  //职务管理 jobManagement
  {
    path: '/jobManagement',
    name: 'jobManagement',
    component: () => import('@/views/systemManagement/jobManagement/jobManagement.vue'),
    meta: {
      auth: true
    }
  },
  //租户管理 tenantManagement
  {
    path: '/tenantManagement',
    name: 'tenantManagement',
    component: () => import('@/views/systemManagement/tenantManagement/tenantManagement.vue'),
    meta: {
      auth: true
    }
  },
  // tenantProductPackage

  //数据字典管理 dataDictionaryManagement
  {
    path: '/dataDictionaryManagement',
    name: 'dataDictionaryManagement',
    component: () => import('@/views/systemManagement/dataDictionaryManagement/dataDictionaryManagement.vue'),
    meta: {
      auth: true
    }
  },
  //通知公告管理 noticeManagement
  {
    path: '/noticeManagement',
    name: 'noticeManagement',
    component: () => import('@/views/systemManagement/noticeManagement/noticeManagement.vue'),
    meta: {
      auth: true
    }
  },
  //菜单管理 menuManagement
  {
    path: '/menuManagement',
    name: 'menuManagement',
    component: () => import('@/views/systemManagement/menuManagement/menuManagement.vue'),
    meta: {
      auth: true
    }
  },
  // portraitLabels  用户标签
  {
    path: '/portraitLabels',
    name: 'portraitLabels',
    component: () => import('@/views/systemManagement/portraitLabels/portraitLabels.vue'),
    meta: {
      auth: true
    }
  },
  //部门管理 departmentManagement
  {
    path: '/departmentManagement',
    name: 'departmentManagement',
    component: () => import('@/views/systemManagement/departmentManagement/departmentManagement.vue'),
    meta: {
      auth: true
    }
  },
  //我的部门myDepartment
  {
    path: '/myDepartment',
    name: 'myDepartment',
    component: () => import('@/views/systemManagement/myDepartment/myDepartment.vue'),
    meta: {
      auth: true
    }
  },
  //我的租户  租户用户
  {
    path: '/tenantUsers',
    name: 'tenantUsers',
    component: () => import('@/views/myTenant/tenantUsers/tenantUsers.vue'),
    meta: {
      auth: true
    }
  },
  //租户角色  tenantRole
  // {
  //   path: '/tenantRole',
  //     name: 'tenantRole',
  //     component: () => import('@/views/myTenant/tenantRole/tenantRole.vue')
  // },
  //日志管理 logManagement
  {
    path: '/logManagement',
    name: 'logManagement',
    component: () => import('@/views/systemMonitor/logManagement/logManagement.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/datalogManagement',
    name: 'datalogManagement',
    component: () => import('@/views/systemMonitor/datalogManagement/datalogManagement.vue'),
    meta: {
      auth: true
    }
  },
  // synchronizeLogs
  {
    path: '/synchronizeLogs',
    name: 'synchronizeLogs',
    component: () => import('@/views/systemMonitor/synchronizeLogs/synchronizeLogs.vue'),
    meta: {
      auth: true
    }
  },
  //messageCenter
  {
    path: '/messageCenter', //系统管理-用户管理
    name: 'messageCenter',
    component: () => import('@/views/systemManagement/messageCenter/messageCenter.vue'),
    meta: {
      auth: true
    }
  },








  //首页个人信息
  {
    path: '/personalInfo',
    name: 'personalInfo',
    component: () => import('../views/login/personalInfo.vue'),
    meta: {
      auth: true
    }
  },
  //首页修改密码
  {
    path: '/changePassword',
    name: 'changePassword',
    component: () => import('../views/login/changePassword.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/testView', //测试路由后续删除
    name: 'testView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/testView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/testTableView', //yxx测试路由1
    name: 'testTableView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/testTableView.vue'),
    meta: {
      auth: true
    }
  },
  // vue基本语法demo页面
  {
    path: '/demoView', //yxx测试路由1
    name: 'demoView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/demoView.vue'),
    meta: {
      auth: true
    }
  },
  ]
},
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {

  const token = store.state.token
  if (to.meta.auth) {
    if (token) {
      next();
    } else {
      next('/login')
    }
  } else {
    next();
  }
  //   if (to.matched.length === 0) {
  //     next('/notFound')
  //   } else {
  //     if (to.meta.auth) {
  //       if (token) {
  //         next();
  //       } else {
  //         next('/login')
  //       }
  //     } else {
  //       next();
  //     }
  //   }

})

export default router